import { Component, inject } from '@angular/core';
import { IncidentPerStandService } from '../proxy/operational/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  IncidentPerStandCreateDto,
  IncidentPerStandDto,
  IncidentPerStandExcelDownloadDto,
  IncidentPerStandUpdateDto,
} from '../proxy/operational/dtos/incident-per-stand';
import { INCIDENTPERSTAND_CONFIG, INCIDENTPERSTAND_FIELDS } from './incident-per-stand.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-incident-per-stand',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, IncidentPerStandService, ConfirmationService],
  templateUrl: './incident-per-stand.html',
  styleUrl: './incident-per-stand.scss',
})
export class IncidentPerStand extends BaseCrudComponent<
  IncidentPerStandDto,
  IncidentPerStandCreateDto,
  IncidentPerStandUpdateDto,
  IncidentPerStandExcelDownloadDto
> {
  service = inject(IncidentPerStandService);
  config = INCIDENTPERSTAND_CONFIG;
  fields = INCIDENTPERSTAND_FIELDS;

  protected prepareUpdateDto(data: any, selected: IncidentPerStandDto): IncidentPerStandUpdateDto {
    return {
      area: data.area,
      incidentId: data.incidentId,
      incidentTypeId: data.incidentTypeId,
      rotationId: data.rotationId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'IncidentPerStand';
  }
}
